import { useState, useEffect } from "react";
import API from "../services/api";
import "../styles/setting.css";

function Settings() {
  const [tab, setTab] = useState("profile");

  const [user, setUser] = useState({});
  const [file, setFile] = useState(null);

  const [password, setPassword] = useState({
    oldPassword: "",
    newPassword: ""
  });

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    const res = await API.get("/users/profile");
    setUser(res.data);
  };

  // PROFILE UPDATE
  const updateProfile = async (e) => {
    e.preventDefault();

    const fd = new FormData();
    fd.append("name", user.name);
    fd.append("email", user.email);
    if (file) fd.append("profile_pic", file);

    await API.put("/users/profile", fd);

    localStorage.setItem("name", user.name);

    alert("Profile Updated ✅");
    fetchProfile();
  };

  // PASSWORD UPDATE
  const updatePassword = async (e) => {
    e.preventDefault();

    await API.put("/users/change-password", password);

    alert("Password Updated 🔐");

    setPassword({ oldPassword: "", newPassword: "" });
  };

  return (
    <div className="settings-container">

      <div className="settings-wrapper">

        {/* HEADER */}
        <div className="settings-header">
          <h2>Settings ⚙️</h2>
          <p>Manage your account preferences</p>
        </div>

        {/* TABS */}
        <div className="settings-tabs">

          <button
            className={tab === "profile" ? "active" : ""}
            onClick={() => setTab("profile")}
          >
            👤 Profile
          </button>

          <button
            className={tab === "security" ? "active" : ""}
            onClick={() => setTab("security")}
          >
            🔐 Security
          </button>

          <button
            className={tab === "preferences" ? "active" : ""}
            onClick={() => setTab("preferences")}
          >
            ⚙️ Preferences
          </button>

        </div>

        {/* CONTENT CARD */}
        <div className="settings-card">

          {/* PROFILE */}
          {tab === "profile" && (
            <form onSubmit={updateProfile}>
              <h3>Profile Settings</h3>

              <input
                value={user.name || ""}
                onChange={(e) =>
                  setUser({ ...user, name: e.target.value })
                }
                placeholder="Name"
              />

              <input
                value={user.email || ""}
                onChange={(e) =>
                  setUser({ ...user, email: e.target.value })
                }
                placeholder="Email"
              />

              <input
                type="file"
                onChange={(e) => setFile(e.target.files[0])}
              />

              <button>Save Changes</button>
            </form>
          )}

          {/* SECURITY */}
          {tab === "security" && (
            <form onSubmit={updatePassword}>
              <h3>Change Password</h3>

              <input
                type="password"
                placeholder="Old Password"
                value={password.oldPassword}
                onChange={(e) =>
                  setPassword({
                    ...password,
                    oldPassword: e.target.value
                  })
                }
              />

              <input
                type="password"
                placeholder="New Password"
                value={password.newPassword}
                onChange={(e) =>
                  setPassword({
                    ...password,
                    newPassword: e.target.value
                  })
                }
              />

              <button>Update Password</button>
            </form>
          )}

          {/* PREFERENCES */}
          {tab === "preferences" && (
            <div>
              <h3>Preferences</h3>

              <label>
                <input type="checkbox" />
                Enable Notifications
              </label>

              <label>
                <input
                  type="checkbox"
                  checked={localStorage.getItem("darkMode") === "true"}
                  onChange={(e) => {
                    const value = e.target.checked;
                    localStorage.setItem("darkMode", value);

                    if (value) {
                      document.body.classList.add("dark");
                    } else {
                      document.body.classList.remove("dark");
                    }
                  }}
                />
                Dark Mode
              </label>

            </div>
          )}

        </div>
      </div>
    </div>
  );
}

export default Settings;